(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ampd-series-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function centerActive(bar) {
    var active = bar.querySelector('.series-bar__tab.is-active');
    if (!active) return;
    // Only when the bar actually overflows (i.e. mobile / narrow screens).
    if (bar.scrollWidth <= bar.clientWidth + 1) return;
    var target = active.offsetLeft - (bar.clientWidth - active.offsetWidth) / 2;
    target = Math.max(0, Math.min(target, bar.scrollWidth - bar.clientWidth));
    bar.scrollLeft = target;
  }
  function run() {
    document.querySelectorAll('.series-bar').forEach(centerActive);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Re-center after full load (icons/fonts can shift widths) and on resize.
  window.addEventListener('load', run);
  window.addEventListener('resize', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ampd-spec-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ampd-spec-tabs')) {
  class AmpdSpecTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.spectabs__tab')];
      this.panels = [...this.querySelectorAll('.spectabs__panel')];
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.tab));
      });
    }
    activate(id) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((p) => p.classList.toggle('is-active', p.dataset.tab === id));
    }
  }
  customElements.define('ampd-spec-tabs', AmpdSpecTabs);

  // Clicking the review stars (Judge.me preview badge near the title) opens the
  // Reviews tab and scrolls down to it.
  // Capture phase: Judge.me's own badge handler calls stopPropagation, so a
  // bubble-phase listener never fires — capture runs before it can stop us.
  document.addEventListener('click', function (e) {
    var badge = e.target.closest ? e.target.closest('.jdgm-prev-badge, .jdgm-preview-badge') : null;
    if (!badge) return;
    var host = document.querySelector('ampd-spec-tabs');
    if (!host || typeof host.activate !== 'function') return;
    if (!host.querySelector('.spectabs__tab[data-tab="reviews"]')) return;
    // Stop Judge.me's own badge handler, which also scrolls (to the widget top)
    // and would override our centred scroll.
    e.preventDefault();
    e.stopPropagation();
    host.activate('reviews');
    // Centre the actual review card in the window (not the top of the section,
    // which left it half on the stars / half on the review). Compute the scroll
    // position explicitly — scrollIntoView({block:'center'}) can centre within a
    // scrollable ancestor. Instant scroll: a smooth scroll over this distance
    // gets interrupted. A short delay lets the just-revealed panel lay out.
    setTimeout(function () {
      var panel = host.querySelector('.spectabs__panel--reviews');
      if (!panel) return;
      var carousel = panel.querySelector('.jdgm-row-carousel');
      var t = (carousel && carousel.offsetParent) ? carousel : (panel.querySelector('.jdgm-rev') || panel);
      var rect = t.getBoundingClientRect();
      var y = window.scrollY + rect.top + rect.height / 2 - window.innerHeight / 2;
      window.scrollTo({ top: Math.max(0, y) });
    }, 120);
  }, true);

  // Drive the review carousel arrows ourselves. Judge.me builds the carousel
  // while the Reviews tab is still hidden (0 width), so it can't measure the
  // overflow and locks its own arrows as "disabled" — leaving them dead. We
  // take over: capture phase + stopImmediatePropagation so ours is the only
  // handler, and we scroll the glider directly by one page (with wrap). Snap is
  // off on the glider, so native smooth scroll works. This never pokes
  // Judge.me's rendering, so the reviews keep showing.
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest
      ? e.target.closest('.jdgm-rev-carousel-prev, .jdgm-rev-carousel-next')
      : null;
    if (!arrow || !arrow.closest('.spectabs__panel--reviews')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var scope = arrow.closest('.jdgm-row-carousel') || arrow.closest('.spectabs__panel--reviews');
    var glider = scope && scope.querySelector('.jdgm-glider');
    if (!glider) return;
    // Advance by whole cards. Pitch = distance between two card starts (card
    // width + its right-margin gap); advancing by a multiple of it keeps every
    // page aligned to a card edge, so the inter-card gap never causes drift.
    var cards = glider.querySelectorAll('.jdgm-glider-track > .jdgm-rev');
    var pitch = (cards.length > 1)
      ? (cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left)
      : glider.clientWidth;
    if (!pitch || pitch < 1) pitch = glider.clientWidth;
    var perPage = Math.max(1, Math.round(glider.clientWidth / pitch)); // 1 mobile, 2 desktop
    var page = perPage * pitch;
    var max = glider.scrollWidth - glider.clientWidth;
    var atEnd = glider.scrollLeft >= max - 4;
    var atStart = glider.scrollLeft <= 4;
    var target;
    if (arrow.classList.contains('jdgm-rev-carousel-next')) {
      target = atEnd ? 0 : Math.min(glider.scrollLeft + page, max); // wrap to start
    } else {
      target = atStart ? max : Math.max(glider.scrollLeft - page, 0); // wrap to end
    }
    glider.scrollTo({ left: target, behavior: 'smooth' });
  }, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ampd-video-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ampd-video-carousel')) {
  class AmpdVideoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.avc__track');
      this.viewport = this.querySelector('.avc__viewport');
      this.cards = [...this.querySelectorAll('.avc__card')];
      this.dots = [...this.querySelectorAll('.avc__dot')];
      if (!this.cards.length) return;

      this.index = 0;
      this.playing = this.dataset.autorotate === 'true';
      this.interval = parseInt(this.dataset.interval, 10) || 6000;

      this.querySelector('.avc__arrow--prev')?.addEventListener('click', () => this.step(-1));
      this.querySelector('.avc__arrow--next')?.addEventListener('click', () => this.step(1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index, 10))));
      this.cards.forEach((card) => {
        card.querySelector('.avc__sound')?.addEventListener('click', (e) => { e.stopPropagation(); this.toggleSound(); });
        card.addEventListener('click', (e) => {
          const i = parseInt(card.dataset.index, 10);
          if (i !== this.index) { this.goTo(i); return; }
          /* Already the centre card: clicking the video itself toggles
             playback, so you don't have to hit the small play button. Scoped to
             the media frame - clicking the quote or the creator's name below it
             shouldn't stop the video, and it would make that text impossible to
             select. The sound button and transport bar both stopPropagation, so
             their clicks never reach here. */
          if (!e.target.closest('.avc__media')) return;
          const native = card.querySelector('video.avc__native-video');
          if (!native) return;
          // Resync on rejection: if the browser refuses to start playback we'd
          // otherwise be left showing a pause icon over a stopped video, with
          // the controls fading out and no way to get them back.
          if (native.paused) native.play().catch(() => this.syncPlayBtn(card));
          else native.pause();
        });
      });

      /* Safety net for the loading="lazy" trap described in the markup above.
         The Liquid asks video_tag for loading="eager", but if a future Shopify
         change ignores that argument the videos would silently stop loading
         again, so strip the attribute here too and kick off resource selection.
         Runs once per element - after the attribute is gone this is a no-op. */
      this.querySelectorAll('video.avc__native-video[loading]').forEach((video) => {
        video.removeAttribute('loading');
        video.load();
      });

      this.playBtn = this.querySelector('.avc__playpause');
      this.playBtn?.addEventListener('click', () => this.toggleAutoRotate());

      this.resizeHandler = () => this.positionTrack();
      window.addEventListener('resize', this.resizeHandler);

      // Progress state. lastRatio lets the rAF loop skip redundant style writes;
      // ytState caches whatever the YouTube player reports back to us.
      this.rafId = null;
      this.lastRatio = -1;
      this.ytState = {};
      this.tickProgress = this.tickProgress.bind(this);
      this.listenForYouTube();
      this.setupTransports();

      this.enableSwipe();
      this.enableWheelNav();

      // Start centred on the middle card so neighbours peek on both sides.
      this.index = Math.floor(this.cards.length / 2);
      this.goTo(this.index, true);
      if (this.playing) this.startTimer();
      this.updatePlayBtn();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.resizeHandler);
      if (this.onYouTubeMessage) window.removeEventListener('message', this.onYouTubeMessage);
      if (this.rafId !== null) cancelAnimationFrame(this.rafId);
      this.stopTimer();
    }

    /**
     * Play/pause + scrub controls for uploaded videos.
     */
    setupTransports() {
      this.cards.forEach((card) => {
        const video = card.querySelector('video.avc__native-video');
        const transport = card.querySelector('[data-transport]');
        if (!video || !transport) return;

        /* The card itself is click-to-activate and the viewport listens for
           swipes, so every control has to stop its events from reaching them -
           otherwise dragging the scrubber would also flick the carousel. */
        ['click', 'pointerdown', 'touchstart'].forEach((type) => {
          transport.addEventListener(type, (e) => e.stopPropagation());
        });

        transport.querySelector('.avc__play').addEventListener('click', () => {
          if (video.paused) video.play().catch(() => this.syncPlayBtn(card));
          else video.pause();
        });

        video.addEventListener('play', () => { this.syncPlayBtn(card); this.startProgress(); });
        video.addEventListener('pause', () => { this.syncPlayBtn(card); this.renderProgress(true); });
        video.addEventListener('seeked', () => this.renderProgress(true));
        video.addEventListener('loadedmetadata', () => this.renderProgress(true));

        this.enableScrub(transport.querySelector('[data-scrub]'), video);
        this.syncPlayBtn(card);
      });
    }

    syncPlayBtn(card) {
      const video = card.querySelector('video.avc__native-video');
      const btn = card.querySelector('.avc__play');
      if (!video) return;
      if (btn) btn.setAttribute('aria-pressed', String(!video.paused));
      // Drives the CSS below: a paused video keeps its controls on screen, a
      // playing one hides them until you hover.
      card.classList.toggle('is-paused', video.paused);
    }

    enableScrub(scrub, video) {
      if (!scrub) return;
      let dragging = false;

      const seek = (e) => {
        if (!video.duration || !isFinite(video.duration)) return;
        const rect = scrub.getBoundingClientRect();
        const ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
        video.currentTime = ratio * video.duration;
        this.renderProgress(true);
      };

      scrub.addEventListener('pointerdown', (e) => {
        dragging = true;
        scrub.classList.add('is-scrubbing');
        // Capture keeps the drag alive even when the cursor leaves the track.
        try { scrub.setPointerCapture(e.pointerId); } catch (err) { /* older browser */ }
        seek(e);
      });
      scrub.addEventListener('pointermove', (e) => { if (dragging) seek(e); });

      const endDrag = (e) => {
        if (!dragging) return;
        dragging = false;
        scrub.classList.remove('is-scrubbing');
        try { scrub.releasePointerCapture(e.pointerId); } catch (err) { /* already gone */ }
      };
      scrub.addEventListener('pointerup', endDrag);
      scrub.addEventListener('pointercancel', endDrag);

      scrub.addEventListener('keydown', (e) => {
        if (!video.duration || !isFinite(video.duration)) return;
        let target = null;
        if (e.key === 'ArrowRight') target = video.currentTime + 5;
        else if (e.key === 'ArrowLeft') target = video.currentTime - 5;
        else if (e.key === 'Home') target = 0;
        else if (e.key === 'End') target = video.duration;
        if (target === null) return;
        e.preventDefault();
        video.currentTime = Math.min(video.duration, Math.max(0, target));
        this.renderProgress(true);
      });
    }

    /**
     * YouTube will report playback position over postMessage, but only after a
     * "listening" handshake - and only because the embed URL already carries
     * enablejsapi=1. If it never answers we simply never get a duration, and
     * renderProgress falls back to a plain pill.
     */
    listenForYouTube() {
      this.onYouTubeMessage = (event) => {
        if (typeof event.data !== 'string' || event.origin.indexOf('youtube') === -1) return;
        let data;
        try { data = JSON.parse(event.data); } catch (err) { return; }
        if (!data || data.event !== 'infoDelivery' || !data.info) return;

        // Only the centre card ever has an iframe, so whatever reports in is it.
        const state = this.ytState[this.index] ||
          (this.ytState[this.index] = { current: 0, duration: 0, playing: false, stamp: 0 });

        if (typeof data.info.duration === 'number' && data.info.duration > 0) state.duration = data.info.duration;
        if (typeof data.info.currentTime === 'number') {
          state.current = data.info.currentTime;
          state.stamp = performance.now();
        }
        if (typeof data.info.playerState === 'number') state.playing = data.info.playerState === 1;
        if (state.playing) this.startProgress();
      };
      window.addEventListener('message', this.onYouTubeMessage);
    }

    handshakeYouTube(iframe) {
      if (!iframe || !iframe.src.includes('youtube')) return;
      let tries = 0;
      const timer = setInterval(() => {
        if (!iframe.isConnected || tries >= 12) { clearInterval(timer); return; }
        try {
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: 'listening', id: this.index, channel: 'widget' }),
            '*'
          );
        } catch (err) { /* player not up yet */ }
        tries += 1;
      }, 400);
    }

    startProgress() {
      if (this.rafId === null) this.rafId = requestAnimationFrame(this.tickProgress);
    }

    tickProgress() {
      this.rafId = null;
      if (!this.isConnected) return;
      if (this.renderProgress()) this.rafId = requestAnimationFrame(this.tickProgress);
    }

    /**
     * Paints the active dot's fill and the transport bar from whatever the
     * current media reports. Returns whether it's still playing, so the rAF
     * loop knows whether to keep going.
     */
    renderProgress(force) {
      const card = this.cards[this.index];
      if (!card) return false;

      const video = card.querySelector('video.avc__native-video');
      let current = 0;
      let duration = 0;
      let playing = false;

      if (video) {
        current = video.currentTime;
        duration = video.duration;
        playing = !video.paused && !video.ended;
      } else {
        const yt = this.ytState[this.index];
        if (yt) {
          duration = yt.duration;
          playing = yt.playing;
          current = yt.current;
          // YouTube only reports a few times a second, so interpolate between
          // updates - otherwise the bar visibly steps instead of sliding.
          if (playing && yt.stamp) current += (performance.now() - yt.stamp) / 1000;
        }
      }

      const usable = !!duration && isFinite(duration) && duration > 0;
      const ratio = usable ? Math.min(1, Math.max(0, current / duration)) : 0;
      const changed = force || Math.abs(ratio - this.lastRatio) > 0.001;

      const dot = this.dots[this.index];
      if (dot) {
        dot.classList.toggle('avc__dot--indeterminate', !usable);
        const fill = dot.querySelector('[data-dot-fill]');
        if (fill && usable && changed) fill.style.transform = 'scaleX(' + ratio + ')';
      }

      if (changed) {
        const transport = card.querySelector('[data-transport]');
        if (transport) {
          const fill = transport.querySelector('[data-scrub-fill]');
          const knob = transport.querySelector('[data-scrub-knob]');
          const scrub = transport.querySelector('[data-scrub]');
          if (fill) fill.style.transform = 'scaleX(' + ratio + ')';
          if (knob) knob.style.left = (ratio * 100) + '%';
          if (scrub) scrub.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
          const cur = transport.querySelector('[data-time-current]');
          const total = transport.querySelector('[data-time-total]');
          if (cur) cur.textContent = AmpdVideoCarousel.formatTime(current);
          if (total) total.textContent = AmpdVideoCarousel.formatTime(usable ? duration : 0);
        }
        this.lastRatio = ratio;
      }

      return playing;
    }

    resetProgress() {
      this.lastRatio = -1;
      this.dots.forEach((dot) => {
        const fill = dot.querySelector('[data-dot-fill]');
        if (fill) fill.style.transform = 'scaleX(0)';
        dot.classList.remove('avc__dot--indeterminate');
      });
      this.cards.forEach((card) => {
        const fill = card.querySelector('[data-scrub-fill]');
        const knob = card.querySelector('[data-scrub-knob]');
        if (fill) fill.style.transform = 'scaleX(0)';
        if (knob) knob.style.left = '0%';
      });
    }

    static formatTime(seconds) {
      const s = (!seconds || !isFinite(seconds) || seconds < 0) ? 0 : seconds;
      return Math.floor(s / 60) + ':' + String(Math.floor(s % 60)).padStart(2, '0');
    }

    step(dir) {
      this.goTo(this.index + dir);
    }

    /**
     * Touch swipe support (mobile). Steps the carousel on a horizontal swipe.
     */
    enableSwipe() {
      let startX = 0;
      let startY = 0;
      let deltaX = 0;
      let deltaY = 0;
      let tracking = false;

      this.viewport.addEventListener('touchstart', (e) => {
        tracking = true;
        deltaX = 0;
        deltaY = 0;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      this.viewport.addEventListener('touchmove', (e) => {
        if (!tracking) return;
        deltaX = e.touches[0].clientX - startX;
        deltaY = e.touches[0].clientY - startY;
      }, { passive: true });

      this.viewport.addEventListener('touchend', () => {
        if (!tracking) return;
        tracking = false;
        if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
          this.swiped = true;
          this.step(deltaX < 0 ? 1 : -1);
          if (this.playing) this.startTimer(); // restart the auto-rotate countdown
          setTimeout(() => { this.swiped = false; }, 150);
        }
      });

      // Suppress the card click that follows a swipe.
      this.viewport.addEventListener('click', (e) => {
        if (this.swiped) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    /**
     * Horizontal scroll support (Magic Mouse, trackpad, shift+wheel).
     *
     * These gestures never fire touch events - they arrive as wheel events
     * carrying deltaX, which is why swiping did nothing while the arrows
     * worked. One flick fires dozens of events with a long momentum tail, so
     * this steps once when the accumulated distance crosses a threshold and
     * then ignores the rest of the gesture until it settles: one flick, one
     * card, rather than skidding through the whole carousel.
     */
    enableWheelNav() {
      const STEP_THRESHOLD = 45; // px of travel before we move a card
      const SETTLE_MS = 220;     // quiet gap that marks the end of a gesture
      let travelled = 0;
      let spent = false;
      let settleTimer = null;

      this.viewport.addEventListener('wheel', (e) => {
        let dx = e.deltaX;
        // A plain wheel mouse has no deltaX; shift+wheel is its horizontal.
        if (!dx && e.shiftKey) dx = e.deltaY;
        if (!dx) return;
        // Leave mostly-vertical gestures alone so the page still scrolls.
        if (!e.shiftKey && Math.abs(dx) <= Math.abs(e.deltaY)) return;

        // deltaMode is usually pixels, but can be lines or pages.
        if (e.deltaMode === 1) dx *= 16;
        else if (e.deltaMode === 2) dx *= 400;

        // Claim the gesture: stops the page scrolling sideways and stops the
        // browser's two-finger back-navigation firing over the carousel.
        e.preventDefault();

        clearTimeout(settleTimer);
        settleTimer = setTimeout(() => { travelled = 0; spent = false; }, SETTLE_MS);
        if (spent) return;

        travelled += dx;
        if (Math.abs(travelled) < STEP_THRESHOLD) return;

        this.step(travelled > 0 ? 1 : -1);
        if (this.playing) this.startTimer(); // restart the auto-rotate countdown
        travelled = 0;
        spent = true;
      }, { passive: false });
    }

    goTo(i, immediate) {
      const count = this.cards.length;
      this.index = (i + count) % count;

      this.cards.forEach((card, idx) => card.classList.toggle('is-active', idx === this.index));
      this.dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === this.index));
      // New card, new timeline - clear the old fill before it can flash.
      this.resetProgress();

      if (immediate) {
        const prev = this.track.style.transition;
        this.track.style.transition = 'none';
        this.positionTrack();
        // Force reflow then restore transition.
        void this.track.offsetWidth;
        this.track.style.transition = prev;
      } else {
        this.positionTrack();
      }

      this.activateVideo();
      this.renderProgress(true);
      this.startProgress();
    }

    positionTrack() {
      const card = this.cards[this.index];
      if (!card) return;
      const offset = card.offsetLeft + (card.offsetWidth / 2) - (this.viewport.clientWidth / 2);
      this.track.style.transform = `translateX(${-offset}px)`;
    }

    /**
     * Injects and plays the active card's video (muted), and clears any other.
     */
    activateVideo() {
      this.cards.forEach((card, idx) => {
        const player = card.querySelector('.avc__player');
        const sound = card.querySelector('.avc__sound');
        // Uploaded videos are already in the DOM (preload="none", so nothing has
        // been fetched yet). Embeds get injected/removed on demand instead.
        const native = player.querySelector('video.avc__native-video');

        if (idx === this.index) {
          if (native) {
            native.play().catch(() => this.syncPlayBtn(card));
          } else if (!player.dataset.loaded) {
            player.innerHTML = AmpdVideoCarousel.buildPlayer(card.dataset.videoUrl);
            player.dataset.loaded = 'true';
            const iframe = player.querySelector('iframe');
            AmpdVideoCarousel.disableCaptions(iframe);
            this.handshakeYouTube(iframe);
          }
          if (sound) sound.setAttribute('aria-pressed', 'false');
        } else {
          if (native) {
            // Rewind and re-mute rather than removing it - blowing away the
            // player's innerHTML would destroy the <video> permanently, and it
            // only exists because Liquid rendered it once.
            native.pause();
            try { native.currentTime = 0; } catch (e) { /* not seekable yet */ }
            native.muted = true;
          } else if (player.dataset.loaded) {
            // Remove off-screen embeds so only the centre video runs.
            player.innerHTML = '';
            delete player.dataset.loaded;
          }
          if (sound) sound.setAttribute('aria-pressed', 'false');
        }
      });
    }

    toggleSound() {
      const card = this.cards[this.index];
      const sound = card.querySelector('.avc__sound');
      const on = sound.getAttribute('aria-pressed') === 'true';
      const next = !on;
      sound.setAttribute('aria-pressed', String(next));

      const video = card.querySelector('video');
      if (video) {
        video.muted = !next;
        if (next) video.play().catch(() => this.syncPlayBtn(card));
        return;
      }
      const iframe = card.querySelector('iframe');
      if (iframe) {
        // Best-effort unmute for YouTube / Vimeo embeds.
        if (iframe.src.includes('youtube')) {
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: next ? 'unMute' : 'mute', args: [] }), '*');
        } else if (iframe.src.includes('vimeo')) {
          iframe.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: next ? 1 : 0 }), '*');
        }
      }
    }

    toggleAutoRotate() {
      this.playing = !this.playing;
      if (this.playing) this.startTimer(); else this.stopTimer();
      this.updatePlayBtn();
    }

    updatePlayBtn() {
      this.playBtn?.setAttribute('aria-pressed', String(this.playing));
    }

    startTimer() {
      this.stopTimer();
      this.timer = setInterval(() => this.step(1), this.interval);
    }

    stopTimer() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    /**
     * Forces YouTube captions off. The cc URL params don't stop auto-captions,
     * so unload the captions module via the iframe API once the player is up.
     * Retries for a few seconds as the player initialises.
     */
    static disableCaptions(iframe) {
      if (!iframe || !iframe.src.includes('youtube')) return;
      const send = () => {
        ['captions', 'cc'].forEach((module) => {
          try {
            iframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: 'unloadModule', args: [module] }),
              '*'
            );
          } catch (e) { /* iframe gone */ }
        });
      };
      let tries = 0;
      const timer = setInterval(() => {
        if (!iframe.isConnected || tries >= 10) { clearInterval(timer); return; }
        send();
        tries += 1;
      }, 500);
    }

    static buildPlayer(url) {
      if (!url) return '';
      const yt = url.match(/(?:youtube\.com\/.*[?&]v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{11})/);
      if (yt) {
        const id = yt[1];
        const src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&playsinline=1&modestbranding=1&rel=0&enablejsapi=1&cc_load_policy=0&cc_lang_pref=none&iv_load_policy=3&fs=0&disablekb=1`;
        return `<iframe src="${src}" allow="autoplay; encrypted-media" allowfullscreen frameborder="0"></iframe>`;
      }
      const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vimeo) {
        const src = `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1&muted=1&loop=1&controls=0&autopause=0`;
        return `<iframe src="${src}" allow="autoplay" allowfullscreen frameborder="0"></iframe>`;
      }
      // Direct video file (mp4/webm/mov).
      return `<video src="${url}" muted loop playsinline autoplay preload="metadata"></video>`;
    }
  }

  customElements.define('ampd-video-carousel', AmpdVideoCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ex-demo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initExDemo(root) {
    if (!root || root.dataset.exDemoReady === 'true') return;
    root.dataset.exDemoReady = 'true';

    var tabs = root.querySelectorAll('[data-ex-demo-tab]');
    var select = root.querySelector('[data-ex-demo-select]');
    var panels = root.querySelectorAll('[data-ex-demo-panel]');

    function show(key) {
      for (var i = 0; i < panels.length; i++) {
        panels[i].hidden = panels[i].getAttribute('data-ex-demo-panel') !== key;
      }
      for (var j = 0; j < tabs.length; j++) {
        var on = tabs[j].getAttribute('data-ex-demo-tab') === key;
        tabs[j].classList.toggle('is-active', on);
        tabs[j].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      if (select && select.value !== key) select.value = key;
    }

    for (var k = 0; k < tabs.length; k++) {
      tabs[k].addEventListener('click', function () {
        show(this.getAttribute('data-ex-demo-tab'));
      });
    }

    if (select) {
      select.addEventListener('change', function () {
        show(select.value);
      });
    }

    // "Change location" in the store bar: back to the picker, focus the selector
    var picker = root.querySelector('[data-ex-demo-picker]');
    var changers = root.querySelectorAll('[data-ex-demo-change]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    for (var c = 0; c < changers.length; c++) {
      changers[c].addEventListener('click', function () {
        if (!picker) return;
        picker.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (select) select.focus({ preventScroll: true });
      });
    }

    // Deep link support, e.g. /pages/ex-demo#ampd-bros
    var hash = window.location.hash.replace('#', '');
    if (hash && root.querySelector('[data-ex-demo-panel="' + hash + '"]')) {
      show(hash);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-ex-demo-root]');
    for (var i = 0; i < roots.length; i++) initExDemo(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ex-demo-root]');
    if (root) initExDemo(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
